import ChartContainer from '../../../Common/Services/charts/apex-charts/ChartContainer';
import useTotalVaccinationByMonth from './hooks/useTotalVaccinationByMonth';

export const TotalVaccinationByMonth = () => {
    const { chartConfig } = useTotalVaccinationByMonth();

    return (
        <ChartContainer
            title={"Evolução mensal do total de vacinação"}
            options={chartConfig.options}
            series={chartConfig.series}
            type="bar"
            height={450}
        />
    );
};
